import React, { useState, useEffect, useMemo } from "react";
import { useSocket } from "../context/SocketProvider";
import axios from "axios";

import * as GroupStyle from "../styles/GroupSettings.style";
import { MediaQuery } from 'react-responsive';
import { Drawer } from 'antd';

import DeviceConfirmButtonModal from './DeviceConfirmButtonModal'
import ModeSelectionModal from './DeviceSettingModeSelectModal'
import TimeModal from './GroupSettingTimeModal'

// Common 아이콘
import CursorSVG from '../imgs/cursor.svg'; 
import MenuLedIcon from '../imgs/ic_menu_led_default.svg';
import MenuResetIcon from '../imgs/ic_menu_reset_default.svg';
import MenuMotionIcon from '../imgs/ic_menu_motion_default.svg';
import MenuSensorIcon from '../imgs/ic_menu_sensor_default.svg';

// Mobile 아이콘
import MenuLedSelectIcon from '../imgs/mobile/ic_mobile_menu_led_selected.svg';
import MenuResetSelectIcon from '../imgs/mobile/ic_mobile_menu_reset_selected.svg';
import MenuMotionSelectIcon from '../imgs/mobile/ic_mobile_menu_motion_selected.svg';
import MenuSensorSelectIcon from '../imgs/mobile/ic_mobile_menu_sensor_selected.svg';

// Tablet 아이콘
import MenuLedSelectTabletIcon from '../imgs/ic_menu_led_selected_tablet.svg';
import MenuResetSelectTabletIcon from '../imgs/ic_menu_reset_selected_tablet.svg';
import MenuSensorSelectTabletIcon from '../imgs/ic_menu_sensor_selected_tablet.svg';

import MenuMotionArrowDownFocusTabletIcon from '../imgs/tablet/ic_tablet_arrow_down_selected.svg';
import MenuMotionArrowDownTabletIcon from '../imgs/tablet/ic_tablet_arrow_down.svg';

//const SOCKET_URL = "http://172.16.20.112:3000"; // socket.io 서버
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버

const ledButtons = [
    { label: 'On', value: 1 },
    { label: 'Off', value: 0 },
    { label: 'Blink', value: 2 },
];

interface IconComponents {
  [key: number]: { default: string; selected: string; }; // 💡 키가 숫자(number)여도 string 값을 가진다는 것을 명시
}
const iconComponents: IconComponents = {
    1: {
        default: MenuLedIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuLedSelectIcon,  // 선택된 아이콘 (예: 파란색)
    },
    2: {
        default: MenuResetIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuResetSelectIcon,  // 선택된 아이콘 (예: 파란색)
    },
    3: {
        default: MenuMotionIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuMotionSelectIcon,    // 기본 아이콘 (예: 회색)
        // selected: '../imgs/ic_menu_motion_selected.svg',  // 선택된 아이콘 (예: 파란색)
    },
    4: {
        default: MenuSensorIcon,    // 기본 아이콘 (예: 회색)
        selected: MenuSensorSelectIcon,    // 기본 아이콘 (예: 회색)
        // selected: '../imgs/ic_menu_motion_selected.svg',  // 선택된 아이콘 (예: 파란색)
    },        
};

interface MenuTexts {
  [key: number]: string; // 💡 키가 숫자(number)여도 string 값을 가진다는 것을 명시
}

const menuTexts: MenuTexts = {
    1: 'LED제어 | 테스트',
    2: '디바이스 | 리셋',
    3: '감지센서 | 설정',
    4: '동작모드 | 설정',    
    // ... 탭이 추가될 경우 여기에 계속 추가
};

const menuIds = [1, 2, 3, 4];

interface UserData {
    role: string;
    // 필요한 다른 속성들...
}

interface Props {
    isOpen: boolean;
    onClose: () => void;
    currentUser: UserData | null;
    deviceNum: number;
    // setShowConfigModal: (v: number) => void;
    selectedSiteId: number | null;
    selectedGroupId: number | null;
    selectedGroupName: string | null;

    deviceSettingTab: number;
    setDeviceSettingTab: (n: number) => void;

    // 디바이스 탭 제어 1 탭 설정 값
    this_brightness: number;
    setThisBrightness: (v: number) => void;
    this_brightnessMode: number;
    setThisBrightnessMode: (v: number) => void;

    // 디바이스 탭 제어 2 탭 설정 값 없음

    // 디바이스 탭 제어 3 탭 설정 값
    this_distanceLeft: number;
    setThisDistanceLeft: (v: number) => void;
    this_distanceRight: number;
    setThisDistanceRight: (v: number) => void;
    this_distanceBottom: number;
    setThisDistanceBottom: (v: number) => void;    

    // Tab 4
    led_mode: number;
    setLed_mode: (v: number) => void;
    maxBright: number;
    setMaxBright: (v: number) => void;
    minBright: number;
    setMinBright: (v: number) => void;
    keepOnTime: number;
    setKeepOnTime: (v: number) => void;
    sideOnLed: number;
    setSideOnLed: (v: number) => void;    
}

const DeviceSetDrawerM: React.FC<Props> = ({
    isOpen,
    onClose,
    currentUser,    
    deviceNum,
    // setShowConfigModal,
    selectedSiteId,
    selectedGroupId,
    selectedGroupName,

    deviceSettingTab,
    setDeviceSettingTab,

    // 디바이스 탭 제어 1 탭 설정 값
    this_brightness,
    setThisBrightness,
    this_brightnessMode,
    setThisBrightnessMode,

    // 디바이스 탭 제어 2 탭 설정 값 없음

    // 디바이스 탭 제어 3 탭 설정 값
    this_distanceLeft,
    setThisDistanceLeft,
    this_distanceRight,
    setThisDistanceRight,
    this_distanceBottom,
    setThisDistanceBottom,     

    // Tab 4
    led_mode,
    setLed_mode,
    maxBright,
    setMaxBright,
    minBright,
    setMinBright,
    keepOnTime,
    setKeepOnTime,
    sideOnLed,
    setSideOnLed,      
}) => {

    const socket = useSocket();

    // 👇 적용 확인 버튼 모달 표시 여부
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    const openConfirmModal = () => setIsConfirmModalOpen(true);
    const closeConfirmModal = () => setIsConfirmModalOpen(false);  

    // 센서 모션 설정
    // 👇 모션 모드 선택 모달 표시 여부 상태 추가
    const [isModeModalOpen, setIsModeModalOpen] = useState(false);
    // 👇 모션 모드 모달 열기/닫기 핸들러
    const openModeModal = () => setIsModeModalOpen(true);
    const closeModeModal = () => setIsModeModalOpen(false);

    const [currentLedmode, setCurrentLedmode] = useState(led_mode);
    const [currentMaxBright, setCurrentMaxBright] = useState(maxBright);
    const [currentMinBright, setCurrentMinBright] = useState(minBright);
    const [currentKeepOnTime, setCurrentKeepOnTime] = useState(keepOnTime);
    const [currentSideOnLed, setCurrentSideOnLed] = useState(sideOnLed);

    const handleModeSelect = (modeValue: number) => {
        setCurrentLedmode(modeValue); // led_mode 상태 업데이트
        closeModeModal();          // 모달 닫기
    };

    // 거리 설정    
    // 💡 로컬 상태 정의: DB에서 가져온 값 또는 부모에서 전달받은 현재 값으로 초기화
    const [localLeft, setLocalLeft] = useState(this_distanceLeft);
    const [localRight, setLocalRight] = useState(this_distanceRight);
    const [localBottom, setLocalBottom] = useState(this_distanceBottom);
    const [isLoading, setIsLoading] = useState(true); // 로딩 상태 추가

    // 💡 2. props 값이 변경될 때 로컬 상태 초기화 (Drawer가 다시 열릴 때 동기화)
    useEffect(() => {
        setLocalLeft(this_distanceLeft);
        setLocalRight(this_distanceRight);
        setLocalBottom(this_distanceBottom);

        setCurrentLedmode(led_mode);
        setCurrentMaxBright(maxBright);
        setCurrentMinBright(minBright);
        setCurrentKeepOnTime(keepOnTime);
        setCurrentSideOnLed(sideOnLed);
    }, [
        this_distanceLeft, this_distanceRight, this_distanceBottom,
        led_mode, minBright, maxBright, keepOnTime, sideOnLed
    ]);

    // 💡 useEffect를 사용하여 디바이스 번호가 변경되거나 Drawer가 열릴 때 DB 값 로드
    useEffect(() => {
        if (!isOpen || !selectedSiteId || !selectedGroupId || deviceNum === 0) {
            // Drawer가 닫혀있거나 필수 ID가 없으면 실행하지 않음
            return;
        }

        const fetchControlSettings = async () => {
            setIsLoading(true);
            try {
                // DB에서 해당 디바이스의 설정값을 가져오는 GET 요청
                //console.log(`[DEBUG_FRONT] siteId: ${selectedSiteId}, groupId: ${selectedGroupId}, deviceNum: ${deviceNum}`);
                const url = `${SOCKET_URL}/api/device/sensorinfo/${selectedSiteId}/${selectedGroupId}/${deviceNum}`;
                const response = await axios.get(url);
                //const data = response.data;

                // 💡 수정된 부분: response.data.data[0] 에 접근
                const dataWrapper = response.data; // { data: [...] }
                const transformedData = dataWrapper.data; // [...] 배열

                // 단일 디바이스 정보를 가져오거나, 데이터가 없을 경우 빈 객체를 사용
                const data = (transformedData && transformedData.length > 0) 
                                    ? transformedData[0] 
                                    : {};                

                // 응답 데이터에서 제어 3 설정값 추출 (예시 필드명 LDistS, RDistS, DDistS)
                const LDistS = data.LDistS !== undefined ? Number(data.LDistS) : 50;
                const RDistS = data.RDistS !== undefined ? Number(data.RDistS) : 50;
                const DDistS = data.DDistS !== undefined ? Number(data.DDistS) : 50;

                const mode = data.mode !== undefined ? Number(data.mode) : 3;
                const maxLED = data.maxLED !== undefined ? Number(data.maxLED) : 100;
                const minLED = data.minLED !== undefined ? Number(data.minLED) : 1;
                const LEDOnT = data.LEDOnT !== undefined ? Number(data.LEDOnT) : 60;
                const sLEDN = data.sLEDN !== undefined ? Number(data.sLEDN) : 5;
                //console.log('==>',RDistS);
                const OnT = data.OnT !== undefined ? Number(data.OnT) : 0;
                const OffT = data.OffT !== undefined ? Number(data.OffT) : 0;

                // 💡 로컬 상태를 DB 값으로 업데이트
                setLocalLeft(LDistS);
                setLocalRight(RDistS);
                setLocalBottom(DDistS);

                setCurrentLedmode(mode);
                setCurrentMaxBright(maxLED);
                setCurrentMinBright(minLED);
                setCurrentKeepOnTime(LEDOnT);
                setCurrentSideOnLed(sLEDN);                  
                // 💡 부모 상태도 로드된 값으로 즉시 업데이트 (필수 아님, 필요에 따라)
                // setThisDistanceLeft(LDistS);
                // setThisDistanceRight(RDistS);
                // setThisDistanceBottom(DDistS);
                const formattedOnTime = minutesToHHMM(OnT ?? 0);
                setSelectedModeOnTime(formattedOnTime);
                const formattedOffTime = minutesToHHMM(OffT ?? 0);
                setSelectedModeOffTime(formattedOffTime);

            } catch (error) {
                console.error(`Device ${deviceNum} 제어 3 설정값 로드 실패:`, error);
                // 로드 실패 시에도 현재 상태 유지 또는 기본값으로 설정
                // setLocalLeft(50); 
                // setLocalRight(50);
                // setLocalBottom(50);
            } finally {
                setIsLoading(false);
            }
        };

        fetchControlSettings();
        // 의존성 배열에 deviceNum, isOpen을 넣어 이 값이 변경될 때마다 재실행
    }, [deviceNum, isOpen, selectedSiteId, selectedGroupId]);
    // 참고: 부모의 setter 함수를 의존성 배열에 넣는 것은 React 훅 규칙을 따릅니다.

    const saveOneDistanceData = async (deviceNumber: number, left: number, right: number, bottom: number) => {
        if (!selectedSiteId || !selectedGroupId) return;

        // 1. 엔드포인트 URL 구성
        // URL에는 식별자만 포함: /api/device/setdistance/siteId/groupId
        const url = `${SOCKET_URL}/api/device/setoendistance/${selectedSiteId}/${selectedGroupId}/${deviceNumber}`;

        // 2. 요청 본문(Body) 데이터 구성
        // NestJS DTO 필드명에 맞춥니다.
        const requestBody = {
            distance_sensor_left: left, // mode
            distance_sensor_right: right, // min -> LED_min_luminosity
            distance_sensor_down: bottom, // max -> LED_max_luminosity
        };
        
        try {
            // 3. Axios PUT 요청
            const response = await axios.put(url, requestBody);
            
            //console.log('one 업데이트 성공:', response.data);
            return response.data;
            
        } catch (error) {
            console.error("one 업데이트 실패:", error);
            throw error; // 에러 처리를 위해 throw
        }

    };

    const saveOneSensorData = async (deviceNumber: number, mode: number, maxLED: number, minLED: number, LEDOnT: number, sLEDN: number, onTime:number, offTime:number) => {
        if (!selectedSiteId || !selectedGroupId) return;

        // 1. 엔드포인트 URL 구성
        // URL에는 식별자만 포함: /api/device/setdistance/siteId/groupId
        const url = `${SOCKET_URL}/api/device/setoensensor/${selectedSiteId}/${selectedGroupId}/${deviceNumber}`;

        // 2. 요청 본문(Body) 데이터 구성
        // NestJS DTO 필드명에 맞춥니다.
        const requestBody = {
            mode: mode, // mode
            LED_max_luminosity: maxLED, // min -> LED_min_luminosity
            LED_min_luminosity: minLED, // max -> LED_max_luminosity
            LED_on_time: LEDOnT,
            side_led_on_dev_num: sLEDN,
            mode_on_time: onTime,
            mode_off_time: offTime,
        };
        
        try {
            // 3. Axios PUT 요청
            const response = await axios.put(url, requestBody);
            
            //console.log('one 업데이트 성공:', response.data);
            return response.data;
            
        } catch (error) {
            console.error("one 업데이트 실패:", error);
            throw error; // 에러 처리를 위해 throw
        }

    };    

    /**
     * minutes (0~1439) → "HH:MM AM/PM"
     */
    function minutesToHHMM(minutes: number) {
        const h24 = Math.floor(minutes / 60);
        const m = minutes % 60;

        const period = h24 >= 12 ? "PM" : "AM";
        let h12 = h24 % 12;
        if (h12 === 0) h12 = 12;

        return `${String(h12).padStart(2, "0")}:${String(m).padStart(2, "0")} ${period}`;
    }

    //     // 총 분 계산
    //     return hour * 60 + minute;
    // };
    const HHMMToMinutes = (timeString: string): number => {
        const trimmedString = timeString.trim();
        
        // 💡 추가: "0" 또는 빈 문자열이 들어오면 0분으로 처리하고 로그를 찍지 않음 (Silent Fail)
        if (trimmedString === "0" || trimmedString === "") {
            return 0;
        }        
        const parts = trimmedString.split(' ');

        if (parts.length === 2) {
            // CASE 1: "hh:mm am/pm" 형식 처리 (기존 로직)
            const [time, period] = parts;
            const [hourStr, minuteStr] = time.split(':');

            if (!hourStr || !minuteStr) return 0;

            let hour = parseInt(hourStr, 10);
            const minute = parseInt(minuteStr, 10);

            if (period.toLowerCase() === 'pm' && hour !== 12) {
                hour += 12;
            } else if (period.toLowerCase() === 'am' && hour === 12) {
                hour = 0;
            }
            return hour * 60 + minute;
        } else if (trimmedString.includes(':')) {
            // CASE 2: "HH:MM:SS" 또는 "HH:MM" 형식 처리 (00:00:00 대응)
            const timeParts = trimmedString.split(':');
            
            const hour = parseInt(timeParts[0], 10);
            const minute = parseInt(timeParts[1], 10);
            
            if (isNaN(hour) || isNaN(minute)) {
                console.error("Invalid time format (contains ':' but failed to parse HH:MM):", trimmedString);
                return 0;
            }
            // 24시간 기준으로 분 계산
            return hour * 60 + minute;
        }

        // 기타 예상치 못한 형식
        console.error("Invalid time format (expected 'hh:mm am/pm' or 'HH:MM:SS'):", trimmedString);
        return 0;
    };

    const formatpaddedId = (num: number, targetLength: number): string => {
        // 1. 숫자를 문자열로 변환합니다.
        const str = String(num);
        // 2. padStart() 메서드를 사용하여 문자열의 시작 부분을 '0'으로 채웁니다.
        return str.padStart(targetLength, '0');
    }

    // 개별 디바이스 제어 설정 값
    const handleApply_DeviceSets = (tabNumber: number, deviceNumber: number) => {
        closeConfirmModal()
        if (!socket || !selectedSiteId || !selectedGroupId) return;

        const sid: string = formatpaddedId(selectedSiteId,4);
        const gid: string = formatpaddedId(selectedGroupId,3);

        let payload: any = { socketId:socket.id , siteId: sid, groupId: gid };
        // let payload: any = { siteId: selectedSiteId, groupId: selectedGroupId };

        
        switch (deviceSettingTab) {
            case 1:
            let LEDSts = this_brightness;
            let LEDTst = this_brightnessMode;
            payload = {
                ...payload,
                tabNumber,
                deviceNumber,
                LEDSts,
                LEDTst, // 라디오 선택지 값 포함
            };
            break;
            case 2:
                payload = {
                    ...payload,
                    tabNumber,
                    deviceNumber,
                };
            break;
            case 3:
                // 💡 로컬 상태의 값을 사용
                let LDistS = localLeft; 
                let RDistS = localRight;
                let DDistS = localBottom;
                
                // 💡 부모 컴포넌트의 상태를 로컬 상태 값으로 업데이트 (상위 컴포넌트의 상태를 최신화)
                // setThisDistanceLeft(LDistS);
                // setThisDistanceRight(RDistS);
                // setThisDistanceBottom(DDistS);

                payload = {
                    ...payload,
                    tabNumber,
                    deviceNumber,
                    LDistS,
                    RDistS,
                    DDistS,
                };
                saveOneDistanceData(deviceNumber,LDistS,RDistS,DDistS);
            break;
            case 4:
                // 💡 로컬 상태의 값을 사용
                let mode = currentLedmode; 
                let maxLED = currentMaxBright;
                let minLED = currentMinBright;
                let LEDOnT = currentKeepOnTime;
                let sLEDN = currentSideOnLed;
                let OnT = 0;
                let OffT = 0;
                if (mode === 1) {
                    OnT = 0;
                    OffT = 0;
                } else {
                    OnT = HHMMToMinutes(selectedModeOnTime);
                    OffT = HHMMToMinutes(selectedModeOffTime);
                }

                payload = {
                    ...payload,
                    tabNumber,
                    deviceNumber,
                    mode,
                    maxLED,
                    minLED,
                    LEDOnT,
                    sLEDN,
                    OnT,
                    OffT,
                };
                saveOneSensorData(deviceNumber,mode,maxLED,minLED,LEDOnT,sLEDN,OnT,OffT);
            break;               
        }
        socket.emit('device_publish', payload);

        //alert(`전송 데이터: ${JSON.stringify(payload, null, 2)}`);
    };    

    // ***************************************************************************
    //  디바이스별 On/Off 시간 
    // ***************************************************************************
    
    // 상태 관리: 모달 열림 여부와 선택된 시간
    const [isModeOnTimeModalOpen, setModeOnTimeIsModalOpen] = useState(false);
    const [selectedModeOnTime, setSelectedModeOnTime] = useState("12:00 AM");
    const [isModeOffTimeModalOpen, setModeOffTimeIsModalOpen] = useState(false);
    const [selectedModeOffTime, setSelectedModeOffTime] = useState("12:00 AM");

    // OnTime 모달 열기 함수
    const handleOpenModeOnTimeModal = () => {
        setModeOnTimeIsModalOpen(true);
    };
    // OnTime 모달 닫기 함수
    const handleCloseModeOnTimeModal = () => {
        setModeOnTimeIsModalOpen(false);
    };
    // OffTime 모달 열기 함수
    const handleOpenModeOffTimeModal = () => {
        setModeOffTimeIsModalOpen(true);
    };
    // OnTime 모달 닫기 함수
    const handleCloseModeOffTimeModal = () => {
        setModeOffTimeIsModalOpen(false);
    };

    // onTime 시간 저장 함수
    const handleSaveModeOnTime = (onTime: string) => {
        setSelectedModeOnTime(onTime);
        setModeOnTimeIsModalOpen(false); // 저장 후 모달 닫기
    };
    // offTime 시간 저장 함수
    const handleSaveModeOffTime = (offTime: string) => {
        setSelectedModeOffTime(offTime);
        setModeOffTimeIsModalOpen(false); // 저장 후 모달 닫기
    };

    // ***************************************************************************
    //  UI
    // ***************************************************************************

    return (
        <>
            <Drawer
                open={isOpen}
                onClose={onClose}
                width={'100vw'}
                height={'100vh'}
                placement={'top'}
                footer={null}
                title={
                    <center><h4>{selectedGroupName} {deviceNum} 제어/설정</h4></center>                
                }

                styles={{
                    body: {
                        backgroundColor: '#F7F7F7', // 연한 분홍색 (Drawer 전체 배경색)
                    },
                }}                
            >

            {currentUser?.role === 'user' ? (
            <>
            <GroupStyle.MainTabContainer>
                
                {/* ✅ 탭별 내용 */}
                {/* Tab 1 */}
                <GroupStyle.CommonMenuArea
                    onClick={() => setDeviceSettingTab(1)} // 클릭 시 1번 탭 활성화
                    isMenuSelected={deviceSettingTab === 1} // 현재 탭이 1번인지 확인
                >

                    <GroupStyle.CommonMenuTitle>
                        <GroupStyle.CommonMenuTitleIcon
                            isMenuSelected={deviceSettingTab === 1}
                            $menuUrl={MenuLedIcon}
                            $selectedMenuUrl={MenuLedSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                        >
                        </GroupStyle.CommonMenuTitleIcon>
                        <GroupStyle.CommonMenuTitleText
                            isMenuSelected={deviceSettingTab === 1} // 현재 탭이 1번인지 확인
                        >
                            &nbsp;LED 제어 테스트
                        </GroupStyle.CommonMenuTitleText>
                    </GroupStyle.CommonMenuTitle>

                    {/* 숫자 입력 */}
                    <GroupStyle.LedControlSelectFrame>

                        {ledButtons.map((button) => {
                            // 🔑 현재 버튼의 value가 상태와 일치하는지 확인
                            const isSelected = button.value === this_brightnessMode;
                            
                            return (
                                <GroupStyle.LedControlSelectFocus isSelected={isSelected}
                                    key={button.value}
                                    onClick={() => setThisBrightnessMode(button.value)}
                                >
                                    <GroupStyle.LedControlSelectFocusText 
                                        isSelected={isSelected}
                                        isMenuSelected={deviceSettingTab === 1}
                                    >
                                        {button.label}
                                    </GroupStyle.LedControlSelectFocusText>
                                </GroupStyle.LedControlSelectFocus>
                            );
                        })}

                    </GroupStyle.LedControlSelectFrame>

                    <GroupStyle.LedBrightFrame>

                        <GroupStyle.LedBrightTextFrame>
                            <GroupStyle.LedBrightText1 isMenuSelected={deviceSettingTab === 1}>
                                밝기
                            </GroupStyle.LedBrightText1>
                            <GroupStyle.LedBrightText2 isMenuSelected={deviceSettingTab === 1}>
                                {this_brightness}
                            </GroupStyle.LedBrightText2>                            
                        </GroupStyle.LedBrightTextFrame>

                        <GroupStyle.LedBrightProgressFrame>
                            <GroupStyle.LedBrightProgressText
                                isMenuSelected={deviceSettingTab === 1}
                            >
                                0
                            </GroupStyle.LedBrightProgressText>
                            <GroupStyle.CommonProgressBarFrame>
                                <GroupStyle.CommonProgressBar>
                                    <GroupStyle.CommonProgressBarCursor
                                        min="0"
                                        max="100"
                                        value={this_brightness}
                                        onChange={(e) => setThisBrightness(Number(e.target.value))}
                                        level={this_brightness} 
                                        $cursorUrl={CursorSVG}
                                    >
                                    </GroupStyle.CommonProgressBarCursor>
                                </GroupStyle.CommonProgressBar>
                            </GroupStyle.CommonProgressBarFrame>
                            <GroupStyle.LedBrightProgressText
                                isMenuSelected={deviceSettingTab === 1}
                            >
                                100
                            </GroupStyle.LedBrightProgressText>
                        </GroupStyle.LedBrightProgressFrame>

                    </GroupStyle.LedBrightFrame>
                
                    <GroupStyle.CommonMenuConfirm
                        isMenuSelected={deviceSettingTab === 1}
                        disabled={deviceSettingTab !== 1} 
                        onClick={(e)=> 
                            {
                                // setDeviceSettingTab(1)
                                e.stopPropagation(); // 영역 클릭 이벤트가 버튼 클릭에 중복되지 않도록 방지
                                handleApply_DeviceSets(1,deviceNum)
                            }
                        }
                    >
                        적용
                    </GroupStyle.CommonMenuConfirm>

                </GroupStyle.CommonMenuArea>

            </GroupStyle.MainTabContainer>
            </>
            ) : (
            <>
            {/* ✅ 3개의 탭 버튼 */}
            <GroupStyle.MainTabContainer>
                <GroupStyle.MenuArea>

                    {menuIds.map((num) => {
                        const isSelected = num === deviceSettingTab;
                        // 선택 여부에 따라 사용할 아이콘 경로 결정
                        const iconSrc = isSelected 
                            ? iconComponents[num].selected  // 선택된 경우: 색상 아이콘
                            : iconComponents[num].default;  // 선택되지 않은 경우: 기본 아이콘                        
                        return (
                        
                        <GroupStyle.MenuFrame
                            key={num}
                            onClick={() => setDeviceSettingTab(num)}
                        >

                            <GroupStyle.MenuIcon
                                style={{ 
                                    backgroundImage: `url(${iconSrc})` 
                                }}
                            >
                            </GroupStyle.MenuIcon>
                            
                            <GroupStyle.MenuText isSelected={isSelected}>
                                {menuTexts[num].split(' | ').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        {index < menuTexts[num].split(' | ').length - 1 && <br />}
                                    </React.Fragment>
                                ))}
                            </GroupStyle.MenuText>

                        </GroupStyle.MenuFrame>
                        )
                    })}

                </GroupStyle.MenuArea>
                {/* ✅ 3개의 탭 버튼 끝 */}


                {/* ✅ 탭별 내용 */}
                {/* Tab 1 */}
                {deviceSettingTab === 1 && (
                    <GroupStyle.CommonMenuArea>

                        <GroupStyle.CommonMenuTitle>
                            <GroupStyle.CommonMenuTitleIcon
                                isMenuSelected={deviceSettingTab === 1}
                                $menuUrl={MenuLedIcon}
                                $selectedMenuUrl={MenuLedSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                            >
                            </GroupStyle.CommonMenuTitleIcon>
                            <GroupStyle.CommonMenuTitleText
                                isMenuSelected={deviceSettingTab === 1} // 현재 탭이 1번인지 확인
                            >
                                &nbsp;LED 제어 테스트
                            </GroupStyle.CommonMenuTitleText>
                        </GroupStyle.CommonMenuTitle>

                        {/* 숫자 입력 */}
                        <GroupStyle.LedControlSelectFrame>

                            {ledButtons.map((button) => {
                                // 🔑 현재 버튼의 value가 상태와 일치하는지 확인
                                const isSelected = button.value === this_brightnessMode;
                                
                                return (
                                    <GroupStyle.LedControlSelectFocus isSelected={isSelected}
                                        key={button.value}
                                        onClick={() => setThisBrightnessMode(button.value)}
                                    >
                                        <GroupStyle.LedControlSelectFocusText 
                                            isSelected={isSelected}
                                            isMenuSelected={deviceSettingTab === 1}
                                        >
                                            {button.label}
                                        </GroupStyle.LedControlSelectFocusText>
                                    </GroupStyle.LedControlSelectFocus>
                                );
                            })}

                        </GroupStyle.LedControlSelectFrame>

                        <GroupStyle.LedBrightFrame>

                            <GroupStyle.LedBrightTextFrame>
                                <GroupStyle.LedBrightText1 isMenuSelected={deviceSettingTab === 1}>
                                    밝기
                                </GroupStyle.LedBrightText1>
                                <GroupStyle.LedBrightText2 isMenuSelected={deviceSettingTab === 1}>
                                    {this_brightness}
                                </GroupStyle.LedBrightText2>                            
                            </GroupStyle.LedBrightTextFrame>

                            <GroupStyle.LedBrightProgressFrame>
                                <GroupStyle.LedBrightProgressText
                                    isMenuSelected={deviceSettingTab === 1}
                                >
                                    0
                                </GroupStyle.LedBrightProgressText>
                                <GroupStyle.CommonProgressBarFrame>
                                    <GroupStyle.CommonProgressBar>
                                        <GroupStyle.CommonProgressBarCursor
                                            min="0"
                                            max="100"
                                            value={this_brightness}
                                            onChange={(e) => setThisBrightness(Number(e.target.value))}
                                            level={this_brightness} 
                                            $cursorUrl={CursorSVG}
                                        >
                                        </GroupStyle.CommonProgressBarCursor>
                                    </GroupStyle.CommonProgressBar>
                                </GroupStyle.CommonProgressBarFrame>
                                <GroupStyle.LedBrightProgressText
                                    isMenuSelected={deviceSettingTab === 1}
                                >
                                    100
                                </GroupStyle.LedBrightProgressText>
                            </GroupStyle.LedBrightProgressFrame>

                        </GroupStyle.LedBrightFrame>
                    
                        <GroupStyle.CommonMenuConfirm
                            isMenuSelected={deviceSettingTab === 1}
                            disabled={deviceSettingTab !== 1} 
                            onClick={(e)=> 
                                {
                                    setDeviceSettingTab(1)
                                    e.stopPropagation(); // 영역 클릭 이벤트가 버튼 클릭에 중복되지 않도록 방지
                                    openConfirmModal()
                                }
                            }
                        >
                            적용
                        </GroupStyle.CommonMenuConfirm>

                    </GroupStyle.CommonMenuArea>
                )}

                {/* Tab 2 */}
                {deviceSettingTab === 2 && (
                    <GroupStyle.CommonMenuArea>

                        <GroupStyle.CommonMenuTitle>
                            <GroupStyle.CommonMenuTitleIcon
                                isMenuSelected={deviceSettingTab === 2}
                                $menuUrl={MenuResetIcon}
                                $selectedMenuUrl={MenuResetSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                            >
                            </GroupStyle.CommonMenuTitleIcon>
                            <GroupStyle.CommonMenuTitleText
                                isMenuSelected={deviceSettingTab === 2} // 현재 탭이 1번인지 확인
                            >
                                &nbsp;&nbsp;&nbsp;디바이스 리셋
                            </GroupStyle.CommonMenuTitleText>
                        </GroupStyle.CommonMenuTitle>
                        
                        <GroupStyle.LedBrightFrame>
                            <GroupStyle.LedBrightText1 isMenuSelected={deviceSettingTab === 2}>
                                적용 버튼을 누르면 <br></br> 해당 디바이스를 <br></br> 리셋 합니다.
                            </GroupStyle.LedBrightText1>
                        </GroupStyle.LedBrightFrame>

                        <GroupStyle.CommonMenuConfirm
                            isMenuSelected={deviceSettingTab === 2}
                            disabled={deviceSettingTab !== 2}                 
                            onClick={()=> 
                                {
                                    setDeviceSettingTab(2)
                                    openConfirmModal()
                                }
                            }
                        >
                            적용
                        </GroupStyle.CommonMenuConfirm>
                    </GroupStyle.CommonMenuArea>
                )}


                {/* Tab 3 */}
                {deviceSettingTab === 3 && (
                    <GroupStyle.CommonMenuArea>

                        <GroupStyle.CommonMenuTitle>
                            <GroupStyle.CommonMenuTitleIcon
                                isMenuSelected={deviceSettingTab === 3}
                                $menuUrl={MenuSensorIcon}
                                $selectedMenuUrl={MenuSensorSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                            >
                            </GroupStyle.CommonMenuTitleIcon>
                            <GroupStyle.CommonMenuTitleText
                                isMenuSelected={deviceSettingTab === 3} // 현재 탭이 1번인지 확인
                            >
                                &nbsp;&nbsp;&nbsp;감지 센서 설정
                            </GroupStyle.CommonMenuTitleText>
                        </GroupStyle.CommonMenuTitle>

                        <GroupStyle.SensorSetFrame>
                            <GroupStyle.SensorSetProgressFrame>
                                <GroupStyle.SensorSetProgressTextLeft
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    왼쪽
                                </GroupStyle.SensorSetProgressTextLeft>
                                <GroupStyle.CommonProgressBarFrame>
                                    <GroupStyle.CommonProgressBar>
                                        <GroupStyle.CommonProgressBarCursor
                                            min="1"
                                            max="100"
                                            value={localLeft}
                                            onChange={(e) => setLocalLeft(Number(e.target.value))}
                                            level={localLeft} 
                                            $cursorUrl={CursorSVG}
                                        >
                                        </GroupStyle.CommonProgressBarCursor>
                                    </GroupStyle.CommonProgressBar>
                                </GroupStyle.CommonProgressBarFrame>
                                <GroupStyle.SensorSetProgressTextRight
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    {localLeft}
                                </GroupStyle.SensorSetProgressTextRight>
                            </GroupStyle.SensorSetProgressFrame>

                            <GroupStyle.SensorSetProgressFrame>
                                <GroupStyle.SensorSetProgressTextLeft
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    오른쪽
                                </GroupStyle.SensorSetProgressTextLeft>
                                <GroupStyle.CommonProgressBarFrame>
                                    <GroupStyle.CommonProgressBar>
                                        <GroupStyle.CommonProgressBarCursor
                                            min="1"
                                            max="100"
                                            value={localRight}
                                            onChange={(e) => setLocalRight(Number(e.target.value))}
                                            level={localRight} 
                                            $cursorUrl={CursorSVG}
                                        >
                                        </GroupStyle.CommonProgressBarCursor>
                                    </GroupStyle.CommonProgressBar>
                                </GroupStyle.CommonProgressBarFrame>
                                <GroupStyle.SensorSetProgressTextRight
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    {localRight}
                                </GroupStyle.SensorSetProgressTextRight>
                            </GroupStyle.SensorSetProgressFrame>

                            <GroupStyle.SensorSetProgressFrame>
                                <GroupStyle.SensorSetProgressTextLeft
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    하단
                                </GroupStyle.SensorSetProgressTextLeft>
                                <GroupStyle.CommonProgressBarFrame>
                                    <GroupStyle.CommonProgressBar>
                                        <GroupStyle.CommonProgressBarCursor
                                            min="1"
                                            max="100"
                                            value={localBottom}
                                            onChange={(e) => setLocalBottom(Number(e.target.value))}
                                            level={localBottom} 
                                            $cursorUrl={CursorSVG}
                                        >
                                        </GroupStyle.CommonProgressBarCursor>
                                    </GroupStyle.CommonProgressBar>
                                </GroupStyle.CommonProgressBarFrame>
                                <GroupStyle.SensorSetProgressTextRight
                                    isMenuSelected={deviceSettingTab === 3}
                                >
                                    {localBottom}
                                </GroupStyle.SensorSetProgressTextRight>
                            </GroupStyle.SensorSetProgressFrame>

                        </GroupStyle.SensorSetFrame>

                        <GroupStyle.CommonMenuConfirm
                            isMenuSelected={deviceSettingTab === 3}
                            disabled={deviceSettingTab !== 3}
                            onClick={()=> 
                                {
                                    setDeviceSettingTab(3)
                                    openConfirmModal()
                                }
                            }
                        >
                            적용
                        </GroupStyle.CommonMenuConfirm>

                    </GroupStyle.CommonMenuArea>
                )}


                {/* Tab 4 */}
                {deviceSettingTab === 4 && (
                    <GroupStyle.CommonMenuArea>

                        <GroupStyle.CommonMenuTitle>
                            <GroupStyle.CommonMenuTitleIcon
                                isMenuSelected={deviceSettingTab === 4}
                                $menuUrl={MenuSensorIcon}
                                $selectedMenuUrl={MenuSensorSelectTabletIcon} // 👈 선택된 아이콘 URL 추가
                            >
                            </GroupStyle.CommonMenuTitleIcon>
                            <GroupStyle.CommonMenuTitleText
                                isMenuSelected={deviceSettingTab === 4} // 현재 탭이 1번인지 확인
                            >
                                &nbsp;&nbsp;&nbsp;동작 모드 설정
                            </GroupStyle.CommonMenuTitleText>
                        </GroupStyle.CommonMenuTitle>

                <GroupStyle.MotionSetFrame
                    onClick={openModeModal}
                >
                    <GroupStyle.MotionSetSelect
                        isMenuSelected={deviceSettingTab === 4}
                    >
                        Mode {Number(currentLedmode)}
                    </GroupStyle.MotionSetSelect>
                    <GroupStyle.MotionSetSelectIcon
                        isMenuSelected={deviceSettingTab === 4}
                        $imgUrl={MenuMotionArrowDownTabletIcon}
                        $selectedimgUrl={MenuMotionArrowDownFocusTabletIcon}
                    >
                    </GroupStyle.MotionSetSelectIcon>

                </GroupStyle.MotionSetFrame>

                <GroupStyle.MotionValueSetFrame>

                    <GroupStyle.MotionValueSetRow>

                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                            >
                                최소밝기
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionValueSetDataFrame>
                                <GroupStyle.MotionValueSetValue
                                    isMenuSelected={deviceSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 0) {
                                            finalValue = 0;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        if(1)
                                        setCurrentMinBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMinBright}
                                </GroupStyle.MotionValueSetValue>
                            </GroupStyle.MotionValueSetDataFrame>
                        </GroupStyle.MotionValueSetCol>

                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                            >
                                최대밝기
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionValueSetDataFrame>
                                <GroupStyle.MotionValueSetValue
                                    isMenuSelected={deviceSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 1) {
                                            finalValue = 1;
                                        } else if (finalValue > 100) {
                                            finalValue = 100;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentMaxBright(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentMaxBright}
                                </GroupStyle.MotionValueSetValue>
                            </GroupStyle.MotionValueSetDataFrame>
                        </GroupStyle.MotionValueSetCol>

                    </GroupStyle.MotionValueSetRow>                      

                    <GroupStyle.MotionValueSetRow>

                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                            >
                                On<br></br>지속시간
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionValueSetDataFrame>
                                <GroupStyle.MotionValueSetValue
                                    isMenuSelected={deviceSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 1) {
                                            finalValue = 1;
                                        } else if (finalValue > 60) {
                                            finalValue = 60;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentKeepOnTime(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentKeepOnTime}
                                </GroupStyle.MotionValueSetValue>
                            </GroupStyle.MotionValueSetDataFrame>
                        </GroupStyle.MotionValueSetCol>

                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                            >
                                좌우 On<br></br>LED 개수
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionValueSetDataFrame>
                                <GroupStyle.MotionValueSetValue
                                    isMenuSelected={deviceSettingTab === 4}
                                    suppressContentEditableWarning={true} // 이 속성을 추가합니다.
                                    contentEditable="true"
                                    inputMode="numeric"
                                    // 🔑 onInput: 입력이 발생할 때마다 실행
                                    onInput={(e) => {
                                        // 1. 입력된 텍스트를 가져옵니다.
                                        let text = e.currentTarget.textContent || '';
                                        
                                        // 2. 텍스트에서 숫자('0'~'9')를 제외한 모든 문자를 제거합니다.
                                        let numericValue = text.replace(/[^0-9]/g, '');
                                        
                                        // 3. 만약 변경된 값이 있다면 DOM을 강제로 업데이트하여 숫자만 남깁니다.
                                        if (text !== numericValue) {
                                            e.currentTarget.textContent = numericValue;
                                        }

                                        // (선택) 상태를 실시간으로 업데이트하려면 여기서 setDisplayValue(numericValue)를 호출합니다.
                                    }}

                                    // onBlur: 포커스를 잃을 때 최종 값을 상태에 저장 (maxBright 업데이트)
                                    onBlur={(e) => {
                                        let finalValue = Number(e.currentTarget.textContent || 0);
                                        // 1. 값의 범위를 제한합니다.
                                        if (finalValue < 1) {
                                            finalValue = 1;
                                        } else if (finalValue > 5) {
                                            finalValue = 5;
                                        }
                                        // 2. 최종 값으로 상태를 업데이트합니다.
                                        setCurrentSideOnLed(finalValue);
                                        
                                        // 3. 화면에 보이는 값도 강제로 업데이트합니다. (필수)
                                        e.currentTarget.textContent = String(finalValue);
                                    }}
                                >
                                    {currentSideOnLed}
                                </GroupStyle.MotionValueSetValue>
                            </GroupStyle.MotionValueSetDataFrame>
                        </GroupStyle.MotionValueSetCol>

                    </GroupStyle.MotionValueSetRow>

                    <GroupStyle.MotionValueSetRow>

                        {/* --- On Time 섹션 --- */}
                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1} // (선택사항) 스타일에서 활용할 프롭
                            >
                                On Time
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOnTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <GroupStyle.MotionInputDataValueTimeText isMenuSelected={deviceSettingTab === 4}>
                                    {selectedModeOnTime || "12:00 AM"}
                                </GroupStyle.MotionInputDataValueTimeText>
                            </GroupStyle.MotionInputDataValueTimeFrame>
                        </GroupStyle.MotionValueSetCol>

                        {/* --- Off Time 섹션 --- */}
                        <GroupStyle.MotionValueSetCol>
                            <GroupStyle.MotionValueSetText
                                isMenuSelected={deviceSettingTab === 4}
                                // isDisabled={Number(currentLedmode) === 1}
                            >
                                Off Time
                            </GroupStyle.MotionValueSetText>
                            <GroupStyle.MotionInputDataValueTimeFrame
                                // 💡 수정: mode가 1이 아닐 때만 클릭 핸들러가 작동하도록 설정
                                onClick={() => Number(currentLedmode) !== 1 && handleOpenModeOffTimeModal()}
                                style={{ 
                                    opacity: Number(currentLedmode) === 1 ? 0.5 : 1, 
                                    cursor: Number(currentLedmode) === 1 ? "not-allowed" : "pointer" 
                                }}
                            >
                                <GroupStyle.MotionInputDataValueTimeText isMenuSelected={deviceSettingTab === 4}>
                                    {selectedModeOffTime || "12:00 AM"}
                                </GroupStyle.MotionInputDataValueTimeText>
                            </GroupStyle.MotionInputDataValueTimeFrame>
                        </GroupStyle.MotionValueSetCol>
                        
                    </GroupStyle.MotionValueSetRow>

                </GroupStyle.MotionValueSetFrame> 

                        <GroupStyle.CommonMenuConfirm
                            isMenuSelected={deviceSettingTab === 4}
                            disabled={deviceSettingTab !== 4}
                            onClick={()=> 
                                {
                                    setDeviceSettingTab(4)
                                    openConfirmModal()
                                }
                            }
                        >
                            적용
                        </GroupStyle.CommonMenuConfirm>

                    </GroupStyle.CommonMenuArea>
                )}
            </GroupStyle.MainTabContainer>
            </>
            )}

            <>
            {/* ✅ 모달 연결 */}
            <TimeModal
                isOpen={isModeOnTimeModalOpen}
                onClose={() => setModeOnTimeIsModalOpen(false)}
                onSave={handleSaveModeOnTime}
                defaultTime={selectedModeOnTime}
            />
            <TimeModal
                isOpen={isModeOffTimeModalOpen}
                onClose={() => setModeOffTimeIsModalOpen(false)}
                onSave={handleSaveModeOffTime}
                defaultTime={selectedModeOffTime}
            />
            </>

            <>
            {/* 👇 LED 모드 선택 모달 컴포넌트 렌더링 */}
            {isModeModalOpen && (
                <ModeSelectionModal
                    open={isModeModalOpen}
                    currentMode={currentLedmode}
                    onSelect={handleModeSelect}
                    onClose={closeModeModal}
                />
            )}
            </>

            <>
            {/* 👇 적용 버튼 모달 컴포넌트 렌더링 */}
            {isConfirmModalOpen && (
                <DeviceConfirmButtonModal
                    isOpen={isConfirmModalOpen}
                    tabNum={deviceSettingTab}
                    deviceNum={deviceNum}                    
                    onAction={handleApply_DeviceSets}
                    onClose={closeConfirmModal}
                />
            )}
            </>

            </Drawer>
        </>
    );
};
export default DeviceSetDrawerM;